import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
  }),
  actions: {
    logoutFromKC() {
      const logoutUrl = (window as any).keycloak.createLogoutUrl();
      window.location.replace(logoutUrl);
    },
  },
});
